/* eslint-disable jsx-a11y/alt-text */
import styled from 'styled-components'
import { SvgIcon } from '@/components'
import { t } from '@/i18n'
export const TaskNameRight = () => (
  <TaskTemplate>
    {/* <div className="header">数据安全</div> */}
    {/* <div className="text" style={{ margin: '18px 0 24px 0' }}>
      本场景通过建设数据安全验证系统，可通过内置敏感数据，及利用算法自动生成敏感数据，并以文档、图片、PDF、附件等多种数据载体，尝试通过邮件、上传、屏蔽信道、第三方应用等通道模拟数据外泄，以验证对数据安全有效性。
    </div> */}
    <div className="header">{t('配置任务基本信息')}</div>
    <div className="step">
      <div className="task">
        <div className="svg-size">
          <Svg name={'phishing-task-name'} />
        </div>
        <div className="text">{t('填写数据安全任务的名称')}</div>
      </div>
      <div className="task-main">
        <div className="task-border" />
      </div>
      <div className="task">
        <div className="svg-size">
          <Svg name={'phishing-task-start'} />
        </div>
        <div className="text">{t('选择任务开始时间')}</div>
      </div>
      <div className="task">
        <div className="svg-size">
          <Svg name={'agent'} />
        </div>
        <div className="text">{t('选取外泄数据的客户端')}</div>
      </div>
      {/* <div className="task">
        <div className="svg-size">
          <Svg name={'处置动作'} />
        </div>
        <div className="text">选择DLP的处置动作</div>
      </div> */}
      <div className="task">
        <div className="svg-size">
          <Svg name={'超时范围'} />
        </div>
        <div className="text">{t('配置上传超时范围')}</div>
      </div>
      <div className="task">
        <div className="svg-size">
          <Svg name={'waf-template'} />
        </div>
        <div className="text">{t('选取模拟外泄敏感数据')}</div>
      </div>
    </div>
  </TaskTemplate>
)
export const PreviewContent = () => {
  const variablesWithInterpretation = [
    { name: 'name_en', value: t('随机英文名字') },
    { name: 'name_cn', value: t('随机中文名字') },
    { name: 'idcard', value: t('随机身份证号') },
    { name: 'bankno', value: t('随机银行卡号') },
    { name: 'phoneno', value: t('随机手机号') },
    { name: 'gender', value: t('随机性别') },
    { name: 'email', value: t('随机邮箱') },
    { name: 'email_account', value: t('生成与当前用户同域的随机邮箱') },
    { name: 'ip_ext', value: t('随机外网ip') },
    { name: 'ip_inter', value: t('随机内网ip') },
    { name: 'HKCardNo', value: t('港澳居民来往内地通行证') },
    { name: 'TWCardNo', value: t('台湾身份证') },
    { name: 'OfficerNo', value: t('军官证') },
    { name: 'AccountNo', value: t('户口本号') },
    { name: 'PassportNo', value: t('护照号码') },
    { name: 'DriverLicenseNo', value: t('驾驶证') },
  ]
  return (
    <TaskTemplate>
      <div className="header">{t('预览内容、替换变量值并选择可测试的文件格式')}</div>
      <div className="step">
        <div className="task">
          <div className="svg-size">
            <Svg name={'数据内容'} />
          </div>
          <div className="text">{t('将要外泄的数据内容')}</div>
        </div>
        <div className="task-main">
          <div className="task-border" />
        </div>
        <div className="task">
          <div className="svg-size">
            <Svg name={'文件格式'} />
          </div>
          <div className="text">{t('选择数据内容的文件格式')}</div>
        </div>
      </div>
      <div style={{ margin: '24px 0 16px' }}>{t('变量及释义：')}</div>
      <div className="variable">
        {variablesWithInterpretation.map((item, index) => (
          <div className="flex" key={index}>
            <div className="text">{`{{${item.name}}}`}</div>
            <div>{item.value}</div>
          </div>
        ))}
        {/* <div className="flex">
          <div className="text">{'{{name_cn}}'}</div>
          <div>随机中文名字</div>
        </div>
        <div className="flex">
          <div className="text">{'{{idcard}}'}</div>
          <div>随机身份证号</div>
        </div>
        <div className="flex">
          <div className="text">{'{{bankno}}'}</div>
          <div>随机银行卡号</div>
        </div>
        <div className="flex">
          <div className="text">{'{{phoneno}}'}</div>
          <div>随机手机号</div>
        </div>
        <div className="flex">
          <div className="text">{'{{gender}}'}</div>
          <div>随机性别</div>
        </div>
        <div className="flex">
          <div className="text">{'{{email}}'}</div>
          <div>随机邮箱</div>
        </div>
        <div className="flex">
          <div className="text">{'{{email_account}}'}</div>
          <div className="text-right">生成与当前用户同域的随机邮箱</div>
        </div>
        <div className="flex">
          <div className="text">{'{{ip_ext}}'}</div>
          <div>随机外网ip</div>
        </div>
        <div className="flex">
          <div className="text">{'{{ip_inter}}'}</div>
          <div>随机内网ip</div>
        </div> */}
      </div>
    </TaskTemplate>
  )
}
export const EscapeMode = () => (
  <TaskTemplate>
    <div className="header">{t('外泄方式')}</div>
    <div className="step">
      <div className="task">
        <div className="svg-size">
          <Svg name={'压缩嵌套'} />
        </div>
        <div className="text">{t('选择文件的压缩嵌套格式')}</div>
      </div>
      <div className="task-main">
        <div className="task-border" />
      </div>
      <div className="task">
        <div className="svg-size">
          <Svg name={'外泄途径'} />
        </div>
        <div className="text">{t('选择外泄途径')}</div>
      </div>
    </div>
  </TaskTemplate>
)
export const Configuration = () => (
  <TaskTemplate>
    <div className="header">{t('任务已配置完成')}</div>
    <div className="step">
      <div className="task">
        <div className="svg-size">
          <Svg name={'phishing-task-over'} />
        </div>
        <div className="text">{t('请确认任务相关配置')}</div>
      </div>
    </div>
  </TaskTemplate>
)
const TaskTemplate = styled.div`
  .header {
    font-size: 16px;
    font-weight: bold;
  }
  .text {
    color: #666666;
    line-height: 22px;
  }
  .step {
    position: relative;
    &::before {
      position: absolute;
      content: '';
      width: 1px;
      height: calc(100% - 100px);
      z-index: 2;
      background-color: #d9d9d9;
      left: 40px;
      top: 20px;
    }
  }
  .task {
    position: relative;
    height: 80px;
    display: flex;
    align-items: center;
    z-index: 9;
    margin-top: 24px;
    .text {
      margin-left: 8px;
    }
  }
  .svg-size {
    width: 80px;
    height: 80px;
    padding: 10px;
    background-color: #fff;
  }
  .variable {
    width: 100%;
    padding: 14px;
    background: #f7f8f9;
    border-radius: 6px;
    .flex {
      display: flex;
      .text {
        width: 178px;
        margin-bottom: 16px;
        color: #86909c;
      }
    }
  }
  .text-right {
    width: calc(100% - 187px);
  }
`
const Svg = styled(SvgIcon)`
  width: 60px;
  height: 60px;
`
